import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { getChecklistRowsSchema } from "../helpers/schemas/getChecklistRowsSchema";

const options = getChecklistRowsSchema().find((e) => e.name === "Row Type");

export default function RowTypeSelect(props) {
  return (
    <FormControl fullWidth>
      <InputLabel id="label">Input Type</InputLabel>
      <Select
        size="small"
        labelId={props.id}
        id={props.id}
        name={props.id}
        value={props.value}
        label="Row Type"
        onChange={(e) => props.onRowTypeChange(e)}
      >
        {options.selectables.map((item) => (
          <MenuItem value={item}>{item}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
